import { FC } from 'react';
import { useMutation } from '@apollo/client';
import { useSetRecoilState } from 'recoil';
import ELEMENT from 'common/element';
import * as K from 'common/constants';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';
import { ACCEPT_LINK_MUTATION } from '../queries';

export const LinkAccountButton: FC<{ token: string }> = ({ token }) => {
  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);

  const handleError = (message: string): void => {
    setPageAlertConfig({
      message,
      variant: PageAlertVariant.ERROR,
      autoHide: true,
      duration: 3,
    });
  };

  const [acceptInvite] = useMutation(ACCEPT_LINK_MUTATION, {
    variables: { token },
    onError: (error) => handleError(error.message),
    onCompleted: (data: { acceptInvite: boolean }) => {
      if (data.acceptInvite) {
        window.location.replace(K.ROUTE.ROOT);
      } else {
        handleError('Operation failed');
      }
    },
  });

  const label = 'Link Account';

  return (
    <Button variant={ButtonVariant.PRIMARY} onClick={() => acceptInvite()} testId={ELEMENT.acceptLinkInviteButtonLink}>
      {label}
    </Button>
  );
};
